import React, { Component } from 'react';
import styled from 'styled-components';

export const Box = styled.div`
  background: ${(props: any) => props.color || '#fff'};
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
` as any;
